import React, { forwardRef } from 'react';

const Image = forwardRef(function Image(
  {
    src,
    alt = 'Image Name',
    className = '',
    onError,
    ...props
  },
  ref,
) {
  const handleError = (event) => {
    event.target.src = '/assets/images/no_image.png';
  };

  return (
    <img
      ref={ref}
      src={src}
      alt={alt}
      className={className}
      onError={onError ?? handleError}
      {...props}
    />
  );
});

export default Image;
